import { useFeed } from './useFeed';
import { subscribeClosingSections, subscribeClosingSubsections, subscribeClosingItems } from '../data/closing';

const NO_ROWS = [];

/** Live Closing walk-through template — sections → sub-sections → items. */
export function useClosing() {
  const sections = useFeed('closing:sections', subscribeClosingSections, { initial: NO_ROWS });
  const subsections = useFeed('closing:subsections', subscribeClosingSubsections, { initial: NO_ROWS });
  const items = useFeed('closing:items', subscribeClosingItems, { initial: NO_ROWS });
  return { sections: sections.data, subsections: subsections.data, items: items.data, loading: sections.loading };
}
